module.exports = __webpack_public_path__ + "img/button_casino_off.f274cca0.png";